import { Group } from '@mantine/core';
import classNames from 'classnames/bind';
import { Logo } from 'components/Logo/Logo';
import { i18nKeys, useTranslation } from 'locales';

import styleIdentifiers from './ServerError.module.scss';

const styles = classNames.bind(styleIdentifiers);

// todo: Correctly identify when the tenant exists, but the user does not have access to it
export function ServerError() {
  const { t } = useTranslation();

  return (
    <div className={styles('server-error-page')}>
      <div className={styles('content-wrapper')}>
        <div className={styles('content', 'card')}>
          <h1>{t(i18nKeys.ERROR.SERVER_NOT_RESPONDING)}</h1>
          <p>{t(i18nKeys.ERROR.REFRESH_PAGE_IF_ERROR_PERSIST)}</p>
        </div>
        <Group w="100%" pt="10px">
          <Logo variant="fullLogo" width={180} />
        </Group>
      </div>
    </div>
  );
}
